import { Button, Row } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
`

export const Wrapper = styled(Row)<{
  $isVisible: boolean;
  $mainColor: string;
  $secondColor: string;
} > `
  position: relative;
  border-radius: 8px;
  padding: 16px 24px 16px 28px;
  margin-bottom: 32px;
  background-color: ${(props) => props.$mainColor};

  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: all 0.25s;
  transform: translateX(${(props) => (props.$isVisible ? 0 : "-24px")});

  .banner-icon {
    > svg {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      margin: 4px 0;
      background: ${(props) => props.$secondColor};
      color: #ffffff;

      > path:first-child {
        color: ${(props) => props.$secondColor};
      }
    }

    &.info-icon {
      transform: rotate(180deg);
    }
  }

  .text-wrapper {
    &-first-child {
      font-size: 16px;
      margin-bottom: 4px;
    }
    &-last-child {
      font-weight: 500;
    }
  }

  .actions-wrapper {
    &${StyledButton} {
      font-weight: 500;
    }

    svg {
      color: ${"#595959"};
      width: 20px;
      height: 20px;
    }
  }

  &::before {
    content: " ";
    display: block;
    width: 8px;
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    background: linear-gradient(
      90deg,
      ${(props) => props.$secondColor} 0%,
      ${(props) => props.$secondColor} 60%,
      ${(props) => props.$mainColor} 60%,
      ${(props) => props.$mainColor} 100%
    );
  }
`;
